export const EDIT_CUSTOMERS_COMMENT_REQUEST = 'EDIT_CUSTOMERS_COMMENT_REQUEST';
export const EDIT_CUSTOMERS_COMMENT_SUCCESS = 'EDIT_CUSTOMERS_COMMENT_SUCCESS';
export const EDIT_CUSTOMERS_COMMENT_FAILURE = 'EDIT_CUSTOMERS_COMMENT_FAILURE';
